import type { AnyComment } from './types';

/**
 * Every comment on screen, replies included, so the heading moves the moment an
 * optimistic comment lands rather than waiting for the post's own count to
 * refetch. Undefined until the comments load, so the caller can fall back.
 */
export const countWithReplies = (comments?: AnyComment[]) =>
  comments?.reduce(
    (total, comment) => total + 1 + ('replies' in comment ? (comment.replies?.length ?? 0) : 0),
    0
  );

/**
 * The comments section's heading carries the count, next to the comments it
 * counts. It used to sit in the pinned comment bar, where it was the one part
 * of the bar that waited on the post and so moved the field when it loaded.
 */
export const commentsHeading = (count: number) => {
  if (count === 0) {
    return 'Comments';
  }

  return count === 1 ? '1 comment' : `${count} comments`;
};
